import React from 'react';
import ReactDOM from 'react-dom';
import FacetCloud from 'components/FacetCloud';

export default function initFacetCloud(selector) {
    const elem = document.querySelector(selector);
    if (!elem) {
        return;
    }
    ReactDOM.render(<FacetCloud />, elem);
}



// WEBPACK FOOTER //
// ./src/widgets/FacetCloud.js